module.exports = __webpack_public_path__ + "static/img/minapp_qw.dcb5b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/minapp_qw.png
// module id = fCq8
// module chunks = 0